<template>
    <dl>
        <slot />
    </dl>
</template>

<script>
export default {
    name: 'accordion-group',
    props: {
        defaultActiveIndex: {
            type: Number,
            default: -1,
        },
    },
    data() {
        return {
            activeIndex: this.defaultActiveIndex,
        };
    },
    methods: {
        makeActive(index) {
            this.activeIndex = this.activeIndex === index ? -1 : index;
        },
    },
};
</script>